import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { Emissaire } from "@/components/Emissaire";

export const Layout = () => (
  <div className="grain relative min-h-screen bg-brand-ink">
    <Header />
    <main className="relative z-10">
      <Outlet />
    </main>
    <Footer />
    <CookieConsent />
    <Emissaire />
  </div>
);
